import {
  Box,
  Button,
  Spinner,
  Stack,
  Text,
  useDisclosure,
  VStack,
} from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  getBoxesTemplates,
  getCategoryTemplates,
  getGoalTemplates,
} from '../../stores/slices/fourBoxesTemplates/fourBoxesTemplatesActions';
import BoxTemplateModal from './4boxes/BoxTemplateModal';
import TemplateList from './4boxes/TemplateList';

const FourBoxes = () => {
  const { boxTemplates } = useSelector(state => state.boxTemplates);
  const [isLoading, setIsLoading] = useState(false);
  const [toUpdate, setToUpdate] = useState({ state: false, template: null });
  const { isOpen, onOpen, onClose } = useDisclosure();
  const dispatch = useDispatch();
  useEffect(() => {
    setIsLoading(true);
    const getTemplates = async () => {
      await Promise.all([
        dispatch(getBoxesTemplates()),
        dispatch(getCategoryTemplates()),
        dispatch(getGoalTemplates()),
      ]);

      setIsLoading(false);
    };
    getTemplates();

    // eslint-disable-next-line
  }, []);

  const onCloseModal = () => {
    onClose();
    setToUpdate({ state: false, doc: null });
  };
  return (
    <React.Fragment>
      <Box w={'full'} overflowX={'hidden'} overflowY={'auto'}>
        <VStack spacing={'4'} h={'full'}>
          <Stack
            justifyContent={'end'}
            alignContent={'center'}
            direction={{ base: 'column', sm: 'row' }}
            w={'full'}
            spacing={4}
            pr={'2'}
            pb={'2'}
            zIndex={'10'}
            sx={{
              position: '-webkit-sticky',
              /* Safari */
              position: 'sticky',
              top: '0',
            }}
            bg={'white'}
            borderBottom={'1px'}
            borderColor={'gray.500'}
          >
            <Button size={'sm'} onClick={onOpen}>
              Add
            </Button>
          </Stack>
          <Box
            overflowX={'auto'}
            w={'full'}
            flex={'1'}
            flexGrow={'1'}
            h={'full'}
          >
            {isLoading ? (
              <Spinner color="primary" />
            ) : boxTemplates.length > 0 ? (
              <TemplateList setToUpdate={setToUpdate} onOpen={onOpen} />
            ) : (
              <Text fontWeight={'bold'} textAlign={'center'}>
                No template found. Please{' '}
                <Button variant="link" color={'primary'} onClick={onOpen}>
                  create
                </Button>{' '}
                a new one.
              </Text>
            )}
          </Box>
        </VStack>
      </Box>
      {isOpen && (
        <BoxTemplateModal
          isOpen={isOpen}
          onClose={onCloseModal}
          toUpdate={toUpdate}
        />
      )}
    </React.Fragment>
  );
};

export default FourBoxes;
